
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cache.cjs.production.min.js')
} else {
  module.exports = require('./cache.cjs.development.js')
}
